import { PointPricePositionEnum } from "@altertec_gparn/lib";

export function getPointPricePositionLabel(value?: PointPricePositionEnum | null): string | null {
  if (value === PointPricePositionEnum.DRIVER) {
    return "Conductor";
  }

  if (value === PointPricePositionEnum.ASSISTANT) {
    return "Auxiliar";
  }

  if (value === PointPricePositionEnum.TECHNICIAN) {
    return "Técnico";
  }

  return null;
}
